import React from 'react';

import BaseIcon, { type BaseIconProps } from '../../BaseIcon';

const OKIcon: React.FC<BaseIconProps> = ({ ...rest }) => {
  return (
    <BaseIcon {...rest} viewBox="0 0 40 40" fill="none">
      <rect width="40" height="40" rx="20" fill="#F7931E" />
      <path
        d="M20.0934 8.8423C16.8996 8.8423 14.3105 11.4315 14.3105 14.6252C14.3105 17.819 16.8996 20.4083 20.0934 20.4083C23.2872 20.4083 25.8762 17.819 25.8762 14.6252C25.8762 11.4315 23.2872 8.8423 20.0934 8.8423ZM20.0934 17.0159C18.7732 17.0159 17.7029 15.9455 17.7029 14.6253C17.7029 13.3051 18.7732 12.2348 20.0934 12.2348C21.4136 12.2348 22.4839 13.3051 22.4839 14.6253C22.4839 15.9455 21.4136 17.0159 20.0934 17.0159Z"
        fill="white"
      />
      <path
        d="M22.136 25.0096C24.4511 24.5379 25.8385 23.4416 25.9119 23.3827C26.5893 22.8394 26.6982 21.8498 26.1549 21.1723C25.6116 20.4949 24.6221 20.386 23.9445 20.9292C23.9302 20.9408 22.4505 22.0759 20.0159 22.0776C17.5814 22.0759 16.0704 20.9408 16.0561 20.9292C15.3785 20.386 14.389 20.4949 13.8458 21.1723C13.3025 21.8498 13.4113 22.8394 14.0887 23.3827C14.1631 23.4424 15.6077 24.5673 17.9877 25.0278L14.6708 28.4943C14.068 29.1195 14.0861 30.1149 14.7112 30.7177C15.0163 31.0119 15.4096 31.1581 15.8025 31.1581C16.2145 31.1581 16.626 30.9971 16.9346 30.6771L20.016 27.3946L23.4087 30.6984C24.0234 31.3121 25.0188 31.3111 25.6323 30.6967C26.2459 30.0821 26.2451 29.0865 25.6306 28.473L22.136 25.0096Z"
        fill="white"
      />
    </BaseIcon>
  );
};

export default OKIcon;
